import { useState } from "react";
import toast from "react-hot-toast";
import "./authForm.scss";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../components/loader/Loader";
import { useForgotPasswordMutation } from "../../features/api/authApiSlice";

import { useRecaptcha, executeRecaptcha } from "../../hooks/useRecaptcha";

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  useRecaptcha(SITE_KEY, ["/forgotpassword"]); // ✅ only show badge on /forgotpassword

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      const token = await executeRecaptcha(SITE_KEY, "forgotpassword");

      await forgotPassword({ email, recaptchaToken: token }).unwrap();
      toast.success("Forgot password email has been sent to your email!");
    } catch (err) {
      console.log("errORRR", err);
      toast.error(err?.data?.message || "Failed to send forgot password email");
    }
  };

  return (
    <div className="auth-form">
      <div className="main">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="auth-from-container">
            <h2>Forgot Password</h2>
            <p>Please enter your email to recover your account.</p>
            <form onSubmit={handleSubmit}>
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                // placeholder="you@example.com"
              />
              <div className="auth-form-links">
                <p>
                  Don't have an account?{" "}
                  <Link to="/become-a-member">Become a Member</Link>
                </p>
                <p>
                  Have an account? <Link to="/login">Login</Link>
                </p>
              </div>
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Sending..." : "Forgot Password"}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
